import { useNavigation } from '@/navigation/NavigationContex';
import { AccordionItem } from '../../components/AccordionItem';
import { AccordionItemContent } from '../../components/AccordionItemContent';
import { AccordionItemHeader } from '../../components/AccordionItemHeader';
import { translate } from '@/translation/translate.ts';
import { RenderField } from '@/form/fields/RenderField';

const AncestryBlack = () => {
  const { currentSlide } = useNavigation();

  const ancestryAfrican = currentSlide!.fields.find(({ name }) => name === 'ancestryAfrican');
  const ancestryBlackCaribbean = currentSlide!.fields.find(({ name }) => name === 'ancestryBlackCaribbean');
  const ancestryAfricanAmerican = currentSlide!.fields.find(({ name }) => name === 'ancestryAfricanAmerican');
  const ancestryBlackSouth = currentSlide!.fields.find(({ name }) => name === 'ancestryBlackSouth');
  const ancestryOtherBlack = currentSlide!.fields.find(({ name }) => name === 'ancestryOtherBlack');

  return (
    <AccordionItem>
      <AccordionItemHeader>{translate(currentSlide?.titles?.black)}</AccordionItemHeader>
      <AccordionItemContent>
        <RenderField slideId={currentSlide!.id} field={ancestryAfrican!} />
        <RenderField slideId={currentSlide!.id} field={ancestryBlackCaribbean!} />
        <RenderField slideId={currentSlide!.id} field={ancestryAfricanAmerican!} />
        <RenderField slideId={currentSlide!.id} field={ancestryBlackSouth!} />
        <RenderField slideId={currentSlide!.id} field={ancestryOtherBlack!} />
      </AccordionItemContent>
    </AccordionItem>
  );
};

export default AncestryBlack;
